import storeApi from "@/services/api/Store";
import { StoreUpdateDTO } from "@/services/api/Store/dtos";
import { IStore } from "@/services/api/Store/types";
import {
  deleteImageFromFirebase,
  uploadOriginalAndPreviewImagesToFirebase,
} from "@/utils/firebase/functions";
import { getStoreImagesFirebasePath } from "@/utils/stringUtils";
import { RefObject } from "react";
import DOMPurify from "dompurify";

export const handleUpdateStore = async (
  storeId: string,
  storeUpdateDto: StoreUpdateDTO,
  updatedOriginalImageArray: string[],
  updatedPreviewImageArray: string[]
) => {
  for (let i = 0; i < storeUpdateDto.imageOriginal.length; i++)
    !updatedOriginalImageArray.includes(storeUpdateDto.imageOriginal[i]) &&
      (await Promise.all([
        deleteImageFromFirebase(storeUpdateDto.imageOriginal[i]),
        deleteImageFromFirebase(storeUpdateDto.imagePreview[i]),
      ]));

  let finalOriginalImages = updatedOriginalImageArray;
  let finalPreviewImages = updatedPreviewImageArray;

  if (storeUpdateDto.images.length > 0) {
    const uploadedImagesResponse =
      await uploadOriginalAndPreviewImagesToFirebase(
        storeUpdateDto.images,
        getStoreImagesFirebasePath(storeUpdateDto?.name, storeId)
      );

    finalOriginalImages.push(...uploadedImagesResponse.originalImageUrls);
    finalPreviewImages.push(...uploadedImagesResponse.previewImageUrls);
  }

  const updatedStoreResponse = await storeApi.updateStore(storeId, {
    name: storeUpdateDto.name,
    email: storeUpdateDto.email,
    CNPJ: storeUpdateDto.CNPJ,
    phone: storeUpdateDto.phone,
    description: DOMPurify.sanitize(storeUpdateDto.description),
    logradouro: storeUpdateDto.logradouro,
    number: storeUpdateDto.number,
    district: storeUpdateDto.district,
    city: storeUpdateDto.city,
    state: storeUpdateDto.state,
    CEP: storeUpdateDto.CEP,
    country: "Brazil",
    lat: storeUpdateDto.lat,
    lng: storeUpdateDto.lng,
    imageOriginal: finalOriginalImages,
    imagePreview: finalPreviewImages,
    listTags: "",
    timeMonday: storeUpdateDto.timeMonday,
    timeTuesday: storeUpdateDto.timeTuesday,
    timeWednesday: storeUpdateDto.timeWednesday,
    timeThursday: storeUpdateDto.timeThursday,
    timeFriday: storeUpdateDto.timeFriday,
    timeSaturday: storeUpdateDto.timeFriday,
    timeSunday: storeUpdateDto.timeSunday,
  } as IStore);

  return updatedStoreResponse;
};

export const focusRefOnError = (
  ref: RefObject<HTMLInputElement>,
  validation: boolean
) => validation && ref.current.focus();
